module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "id": "one"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PART ONE")])]), _vm._v(" "), _c('h1', {
    staticClass: "chaptitle"
  }, [_vm._v("UFOs")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotetext"
  }, [_c('i', [_vm._v("Pure logical thinking cannot yield us any knowledge of the empirical world; all knowledge of reality starts from experience and ends in it.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_vm._v("—Albert Einstein")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98285c68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_partone.vue
// module id = 72
// module chunks = 0